/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Filter_AllInputs */



/**
* | output |
* | --- |
* | "Everyone ({count})" |
*
* @param {Team_Filter_AllInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_filter_all = /** @type {((inputs: Team_Filter_AllInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Filter_AllInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Iedereen (${i?.count})`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Tout le monde (${i?.count})`)
	return /** @type {LocalizedString} */ (`Everyone (${i?.count})`)
});